import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function ChevronUp({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <ChevronUp.Outline {...props} />
  ) : (
    <ChevronUp.Solid {...props} />
  );
}

ChevronUp.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

ChevronUp.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          d="M18.7498 15.3752L11.9998 8.62525L5.24976 15.3752"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
